import type { ListQuery, Page } from "./DocumentList.tsx";

/** Страница сервера (wilco.web.api.CursorPage) в форме Page: у контракта `next` необязательный. */
export const serverPage = <Row>(p: { items: Row[]; next?: string | null }): Page<Row> => ({ items: p.items, next: p.next ?? null });

/** Курсор и размер страницы в query-параметры сервера. */
export const pageQuery = (q: Pick<ListQuery, "cursor" | "limit">) => ({ cursor: q.cursor ?? undefined, limit: q.limit });
